<div class="wrapper">
    <p class="font-weight-bold title">
        Aktivität
    </p>

    <p class="text-muted sub-title">
        Hier werden die Hintergrundaktivitäten des Services aufgelistet.
    </p>

    <div class="card">
        <div class="card-body">
            <app-table-header
                    [pageIndex]="0"
                    [pageCount]="1"
                    [error]="activityService.error"
                    [loading]="activityService.loading"
                    [disableFilter]="true"
                    (reload)="activityService.fetchData()"
            >
            </app-table-header>
            <ng-container *ngIf="activityService.data != null">
                <ng-container *ngIf="activityService.data.tasks.length == 0">
                    <p class="no-activity-label">Keine Aktivität zur Zeit.</p>
                </ng-container>
                <ng-container *ngIf="activityService.data.tasks.length > 0">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>
                                <p>Typ</p>
                            </th>
                            <th>
                                <p>Erzeugt</p>
                            </th>
                            <th>
                                <p>Start</p>
                            </th>
                            <th>
                                <p>Ende</p>
                            </th>
                            <th>
                                <p>Fortschritt</p>
                            </th>
                            <th>
                                <p>Nachricht</p>
                            </th>
                            <th>
                                <p>Download</p>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let task of activityService.data.tasks">
                            <td>
                                <p class="font-weight-bold">
                                    {{getTypeDisplay(task.type)}}
                                </p>
                            </td>
                            <td>
                                <p class="text-muted">
                                    {{getDate(task.created)}}
                                </p>
                            </td>
                            <td>
                                <p class="text-muted">
                                    {{getDate(task.start)}}
                                </p>
                            </td>
                            <td>
                                <ng-container *ngIf="task.end != null && task.start != null">
                                    <p class="text-muted">
                                        {{getDate(task.end)}}
                                    </p>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="task.state == TaskState.running">
                                    <div class="spinner-border text-primary activity-accessory">
                                    </div>
                                    <p>{{getProgressDisplay(task.progress)}}</p>
                                </ng-container>
                                <ng-container *ngIf="task.state == TaskState.pending">
                                    <p>Warten...</p>
                                </ng-container>
                                <ng-container *ngIf="task.state == TaskState.done">
                                    <fa-icon
                                        class="text-success activity-accessory"
                                        [icon]="faCheck"
                                    ></fa-icon>
                                    <p>
                                        Fertig
                                        <span class="text-muted">({{getDurationSeconds(task.start, task.end)}} s)</span>
                                    </p>
                                </ng-container>
                                <ng-container *ngIf="task.state == TaskState.error">
                                    <fa-icon
                                            class="text-danger activity-accessory"
                                            [icon]="faExclamationCircle"
                                    ></fa-icon>
                                    <p>
                                        Fehler
                                        <span class="text-muted">({{getDurationSeconds(task.start, task.end)}} s)</span>
                                    </p>
                                </ng-container>

                            </td>
                            <td>
                                <ng-container *ngIf="task.message != null">
                                    <p class="text-muted">{{task.message}}</p>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="task.artifact != null">
                                    <a href="/api/artifact/{{task.artifact}}" target="_blank">
                                        <fa-icon style="margin-right: 5px;" [icon]="faFile"></fa-icon>
                                        <p>
                                            {{task.artifact}}
                                        </p>
                                    </a>
                                </ng-container>
                                <ng-container *ngIf="task.artifact == null">
                                    -
                                </ng-container>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
